import { useState } from 'react';

type PasswordInputProps = {
  id: string;
  value: string;
  onChange: (value: string) => void;
  className: string;
  placeholder?: string;
  required?: boolean;
  minLength?: number;
  autoComplete?: string;
};

/**
 * 密碼輸入欄位（含顯示/隱藏切換），供前台會員相關表單（登入、註冊、忘記密碼、會員中心改密碼等）共用。
 * className 由呼叫端傳入既有的輸入框樣式，這裡只負責補上右側留白（pr-11）給切換按鈕使用。
 */
export default function PasswordInput({
  id,
  value,
  onChange,
  className,
  placeholder,
  required,
  minLength,
  autoComplete,
}: PasswordInputProps) {
  const [visible, setVisible] = useState(false);

  return (
    <div className="relative">
      <input
        id={id}
        type={visible ? 'text' : 'password'}
        required={required}
        minLength={minLength}
        autoComplete={autoComplete}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={`${className} pr-11`}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setVisible((current) => !current)}
        aria-label={visible ? '隱藏密碼' : '顯示密碼'}
        className="absolute right-1 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center text-[#9A8A7A] hover:text-[#1B3D2A] transition-colors"
      >
        <i className={visible ? 'ri-eye-off-line' : 'ri-eye-line'} />
      </button>
    </div>
  );
}
